import React, { memo } from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

const BbbImg = styled.img`
	margin-bottom: 24px;
	width: ${({ logoWidth }) => logoWidth};
`

const BbbLogo = ({ logoWidth }) => (
	<a
		href="//www.bbb.org/boston/business-reviews/administrative-services/buyerzone-com-llc-in-waltham-ma-87942/#bbbonlineclick"
		rel="noopener noreferrer nofollow"
		target="_blank"
	>
		<BbbImg
			alt="BuyerZone.com, LLC BBB Business Review"
			logoWidth={logoWidth}
			src="https://seal-boston.bbb.org/seals/blue-seal-160-82-bbb-87942.png"
		/>
	</a>
)

BbbLogo.defaultProps = {
	logoWidth: '100%',
}

BbbLogo.propTypes = {
	logoWidth: string,
}

export default memo(BbbLogo)
